export default __webpack_public_path__ + "sleepy-cloud.png";